import script from "./SinglePodcastMinimized.vue?vue&type=script&setup=true&lang=js"
export * from "./SinglePodcastMinimized.vue?vue&type=script&setup=true&lang=js"

import "./SinglePodcastMinimized.vue?vue&type=style&index=0&id=3bc4452e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc4452e"]])

export default __exports__